import dayjs from 'dayjs/esm';

export class User {
  id: number;
  login: string;
  firstName: string;
  lastName: string;
  email: string;
  imageUrl: string;
  activated: boolean;
  langKey: string;
  createdBy: string;
  createdDate?: dayjs.Dayjs;
  lastModifiedBy: string;
  lastModifiedDate?: dayjs.Dayjs;
  authorities: string[];

  constructor(data?: Partial<User>) {
    this.id = data?.id ?? 0;
    this.login = data?.login ?? '';
    this.firstName = data?.firstName ?? '';
    this.lastName = data?.lastName ?? '';
    this.email = data?.email ?? '';
    this.imageUrl = data?.imageUrl ?? '';
    this.activated = data?.activated ?? false;
    this.langKey = data?.langKey ?? 'tr';
    this.createdBy = data?.createdBy ?? '';
    this.createdDate = data?.createdDate ? dayjs(data.createdDate) : undefined;
    this.lastModifiedBy = data?.lastModifiedBy ?? '';
    this.lastModifiedDate = data?.lastModifiedDate ? dayjs(data.lastModifiedDate) : undefined;
    this.authorities = data?.authorities ?? [];
  }
}

export interface KcUserStatus {
  kcId: string | null;
  kcUsername: string | null;
  kcEmail: string | null;
  linked: boolean;
  kcEnabled: boolean;
}

export interface UserSyncResult {
  created: number;
  updated: number;
  skipped: number;
}
